export default __webpack_public_path__ + "static/media/build.eda19a9b.svg";